import { LoadingButton } from "@mui/lab";
import { Box, Dialog, Typography, Button } from "@mui/material";
import { useTranslation } from "react-i18next";

interface Props {
    open: boolean,
    title: string,
    loading: boolean,
    onCancel: VoidFunction,
    onConfirm: VoidFunction
}


const ConfirmDialog = ({ open, title, loading, onCancel, onConfirm }: Props) => {
    const { t } = useTranslation("global");
    return <Dialog
        open={open}
    >
        <Box sx={{ width: '350px', height: '150px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Box>
                <Typography variant='h6'>{title}</Typography>
                <Box mt={2} sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Button variant='contained' color='error' onClick={onCancel} sx={{ textTransform: 'none', mr: 1, width: 100, height: 40 }}>
                        {t("No")}
                    </Button>
                    <Button variant='contained' color='primary' disabled={loading} onClick={onConfirm} sx={{ textTransform: 'none', color: '#fff', width: 100, height: 40 }}>
                        {
                            loading ?
                                <LoadingButton loading >
                                    Loading...
                                </LoadingButton>
                                :  t("Yes")
                        }
                    </Button>
                </Box>
            </Box>
        </Box>
    </Dialog>
}
export default ConfirmDialog;